// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper/bundle';

const initSwiperSections = (selector = '[data-slider]') => {
  const swiperInstances = [];
  const sliderEls = document.querySelectorAll(selector);
  sliderEls.forEach((sliderEl) => {
    const { id } = sliderEl;
    const data = JSON.parse(sliderEl.dataset.sliderSettings);

    const swiper = new Swiper(`#${id}`, data);
    swiper.on('slideChange', () => {
      swiper.pagination.render();
      swiper.pagination.update();
    });

    if (sliderEl.dataset.zoom && !matchMedia('(hover: none)').matches) {
      /* zoom in on hover */
      swiper.el.addEventListener('mouseover', () => {
        const active = swiper.el.querySelector('.swiper-slide-active');
        /* check if already zoomed, so the zoom position is not reset */
        if (!active.classList.contains('swiper-slide-zoomed')) {
          swiper.zoom.in();
        }
      });
      /* unzoom if mouse left the slider */
      swiper.el.addEventListener('mouseleave', () => {
        swiper.zoom.out();
      });

      /* ensure no slides are zoomed on slide change */
      swiper.on('activeIndexChange', (e) => {
        e.zoom.out();
        e.once('slideChangeTransitionEnd', (s) => { s.zoom.out(); });
      });
    }
    swiperInstances.push(swiper);
  });

  return swiperInstances;
};

export default initSwiperSections;
